<script setup lang="ts">
const form = useForm<App.Data.Competitor.CreateCompetitorData>({
	method: 'POST',
	url: route('competitors.store'),
	fields: {
		name: '',
		store_url: '',
	},
	errorBag: 'createCompetitor',
	reset: false,
})
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper>
		<ui-form variant="settings" @submit.prevent="form.submit">
			<ui-form-settings-item>
				<template #label>
					<ui-label for="name">
						{{ t('validation.attributes.name') }}
					</ui-label>
				</template>

				<ui-input
					id="name"
					v-model="form.fields.name"
					required
					autofocus
				/>
				<ui-form-error :message="form.errors.name" />
			</ui-form-settings-item>

			<ui-form-settings-item>
				<template #label>
					<ui-label for="store_url">
						{{ t('validation.attributes.store_url') }}
					</ui-label>
				</template>

				<ui-input
					id="store_url"
					v-model="form.fields.store_url"
					required
					type="url"
				/>
				<ui-form-error :message="form.errors.store_url" />
			</ui-form-settings-item>

			<ui-separator />

			<ui-button :loading="form.processing" class="w-fit" @click="form.submit">
				{{ t('app.buttons.save') }}
				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>
		</ui-form>
	</content-wrapper>
</template>
